/* eslint-disable import/no-unresolved */
 <template>
  <v-main>
    <LoginModal
      :show="showLogin"
      :alert="loginAlert"
      :action="loginAction"
      @credentials="loginUser"
    />
    <v-container fluid class="pa-0" v-if="!showLogin">
      <v-card
        height="100vh"
        class="d-flex flex-column elevation-0 hide-overflow"
      >
        <section class="search-row b-b">
          <PositionSearch admin />
          <v-tabs v-model="activeTab" v-if="loggedIn">
            <v-tab v-for="tab in tabs" :key="tab.id" :to="tab.id" v-show="checkAccess(tab.roles)">
              {{tab.title}}
            </v-tab>
          </v-tabs>
        </section>
        <v-row v-if="loading">
          <v-col>
            <Loader />
          </v-col>
        </v-row>
        <section
          v-else-if="errored"
          style="
            padding: 0 2em;
            height: 82vh;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
          "
        >
          <p>
            We're sorry, we're not able to retrieve this information at the
            moment, please try back later
          </p>
        </section>
        <v-row
          no-gutters
          class="hide-overflow flex-nowrap"
          style="flex: 100%"
          v-else-if="activeTab == '/admin/campaigns'"
        >
          <v-col class="b-r">
            <v-row no-gutters class="align-center justify-space-between">
              <v-col cols="3">
                <v-select
                  no-gutter
                  v-model="campaignFilter"
                  :items="campaignFilters"
                  prepend-icon="mdi-filter"
                  :menu-props="{ top: false, offsetY: true }"
                ></v-select>
              </v-col>
              <v-col cols="4" class="mr-2 text-right">
                <CampaignEditor
                  :showDialog="editCampaign"
                  :editCampaign="selectedCampaign"
                  @campaignCreated="campaignCreated"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <CampaignList
                :search="campaignFilter"
                @selectCampaign="selectCampaign"
                @showDialog="editCampaign = true"
              />
            </v-row>
          </v-col>
          <v-col
            style="position: relative"
            class="ma-2"
            v-if="selectedCampaign !== null"
          >
            <v-card color="primary">
              <div class="campaign-header pa-4">
                <!-- <img
                  :src="selectedCampaign.imageUrl"
                  style="max-width: 200px"
                  class="mb-4"
                /> -->
                <h2
                  class="mb-4"
                  style="color: white; text-transform: uppercase"
                >
                  {{ selectedCampaign.title }}
                </h2>
                <p style="color: white">{{ selectedCampaign.description }}</p>
                <v-btn v-if="selectedCampaign.externalUrl" text color="white">
                  Read more
                  <v-icon right dense>mdi-open-in-new</v-icon>
                </v-btn>
              </div>
              <v-data-table
                :headers="campaignHeaders"
                :items="showCampaignJobs ? getCampaignJobs : getSearchResults"
                :items-per-page="10"
                style="width: 100%"
              ></v-data-table>
            </v-card>
            <!-- <iframe
              :src="'https://placeholder.com/'"
              style="
                width: 100%;
                height: 100%;
                border: 4px solid rgba(0, 0, 0, 0.2);
                box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.2);
                border-radius: 10px;
              "
            >
            </iframe> -->
            <div
              style="
                box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
                font-size: 0.8rem;
                position: absolute;
                top: 0;
                right: 0;
                display: block;
                padding: 0.5rem 1rem;
                background: white;
                border-radius: 6px;
                text-transform: uppercase;
              "
            >
              Campaign preview
            </div>
          </v-col>
          <v-col
                class="hide-overflow d-flex align-center justify-center"
                v-else
              >
                Select a campaign
              </v-col>
        </v-row>
        <v-row
          no-gutters
          class="hide-overflow flex-nowrap"
          style="flex: 100%"
          v-else-if="activeTab == '/admin/users'"
        >
          <v-col class="b-r auto-overflow">
            <v-row no-gutters class="align-center justify-space-between">
              <v-col class="col-md-3">
                <v-select
                  no-gutter
                  v-model="userFilter"
                  :items="userFilters"
                  prepend-icon="mdi-filter"
                  :menu-props="{ top: false, offsetY: true }"
                ></v-select>
              </v-col>
              <v-col class="col-md-3 mr-2 text-right">
                <v-btn color="primary" v-on:click="addUser()">
                  <v-icon left dense>mdi-plus</v-icon>
                  Add user
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <UserList @selectUser="selectUser" :search="userFilter" />
            </v-row>
          </v-col>
          <v-col cols="12" md="4" style="position: relative" v-if="editUser">
            <UserEdit :user="selectedUser" @saved="userSaved" />
          </v-col>
          <v-col
            cols="12"
            md="4"
            style="position: relative"
            class="hide-overflow d-flex align-center justify-center"
            v-else
          >
            Select a user
          </v-col>
        </v-row>
        <v-row
          no-gutters
          class="hide-overflow flex-nowrap"
          style="flex: 100%"
          v-else-if="activeTab == '/admin/content'"
        >
          <v-col class="b-r">
            <!-- <v-row no-gutters class="align-center justify-space-between">
              <v-col class="col-md-3">
                <v-select
                  no-gutter
                  v-model="pageFilter"
                  :items="pageFilters"
                  prepend-icon="mdi-filter"
                  :menu-props="{ top: false, offsetY: true }"
                ></v-select>
              </v-col>
              <v-col class="col-md-3 mr-2 text-right">
                <v-btn color="primary" v-on:click="addUser()">
                  <v-icon left dense>mdi-plus</v-icon>
                  Add page
                </v-btn>
              </v-col>
            </v-row> -->
            <v-row no-gutters>
              <ContentList @selectPage="selectPage" :search="pageFilter" />
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="6"
            style="position: relative"
            class="auto-overflow"
            v-if="editPage"
          >
            <ContentEditor :page="selectedPage" @saved="pageSaved" />
          </v-col>
          <v-col
            cols="12"
            md="6"
            style="position: relative"
            class="hide-overflow d-flex align-center justify-center"
            v-else
          >
            Select a page
          </v-col>
        </v-row>
        <v-row
          v-else-if="activeTab == '/admin/info'"
          no-gutters
          class="hide-overflow flex-nowrap"
        >
          <v-col v-if="getPage">
            <v-col cols="12" md="4" v-if="getPage.content.side.length > 0">
              <v-card class="pa-0 ma-0">
                <div class="ml-4 mr-4 pt-4 pb-1">
                  <ContentRenderer
                    :content="getPage.content.side"
                    class="mb-4"
                  />
                </div>
              </v-card>
            </v-col>
            <v-col cols="12" md="8">
              <ContentRenderer :content="getPage.content.main" />
            </v-col>
          </v-col>
          <v-col
            class="hide-overflow d-flex align-center justify-center"
            v-else
          >
            Page not found.
          </v-col>
        </v-row>
        <v-row
          v-else-if="activeTab == '/admin/policies'"
          no-gutters
          class="hide-overflow flex-nowrap"
        >
          <v-col cols="12" md="12">
            <PolicyList />
          </v-col>
        </v-row>
        <v-row v-else no-gutters class="hide-overflow flex-nowrap h-100">
          <!-- <v-col cols="12" class="hide-overflow b-r">
            <PositionList :graph="getSearchResults" admin />
          </v-col> -->
          <!-- <v-col cols="12" md="3" class="hide-overflow flex-nowrap">
            <PositionEdit />
          </v-col> -->
          <v-col class="hide-overflow">
            <PositionListAdmin />
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import PositionList from "@/components/PositionList.vue";
import PositionListAdmin from "@/components/PositionListAdmin.vue";
import PositionSearch from "@/components/PositionSearch.vue";
import PositionCount from "@/components/PositionCount.vue";
import PositionEdit from "@/components/PositionEdit.vue";
import Loader from "@/components/Loader.vue";
import LoginModal from "@/components/LoginModal.vue";
import CampaignList from "@/components/CampaignList.vue";
import CampaignEditor from "@/components/CampaignEditor.vue";
import UserList from "@/components/UserList.vue";
import UserEdit from "@/components/UserEdit.vue";
import ContentList from "@/components/ContentList.vue";
import ContentEditor from "@/components/ContentEditor.vue";
import ContentRenderer from "@/components/ContentRenderer.vue";
import PolicyList from "@/components/PolicyList.vue";
import PolicyEditor from "@/components/PolicyEditor.vue";

import PositionNew from "@/components/PositionNew.vue";

export default {
  name: "Admin",
  components: {
    PositionCount,
    PositionList,
    PositionListAdmin,
    PositionSearch,
    PositionEdit,
    Loader,
    PositionNew,
    LoginModal,
    CampaignList,
    CampaignEditor,
    UserList,
    UserEdit,
    ContentList,
    ContentEditor,
    ContentRenderer,
    PolicyList,
    PolicyEditor,
  },
  data() {
    return {
      showLogin: false,
      loggedIn: false,
      loginAlert: null,
      tab: null,
      errored: false,
      loading: true,
      positionCount: 0,
      activeTab: null,
      tabs: [
        {
          id: "/admin",
          title: "Jobs",
          roles: ['superadmin', 'jobster', "user"]
        },
        {
          id: "/admin/campaigns",
          title: "Campaigns",
          roles: ['superadmin', 'jobster']
        },
        {
          id: "/admin/policies",
          title: "Policies",
          roles: ['superadmin', 'jobster']
        },
        {
          id: "/admin/users",
          title: "Users",
          roles: ['superadmin', 'jobster']
        },
        {
          id: "/admin/content",
          title: "Content",
          roles: ['superadmin']
        },
        {
          id: "/admin/info",
          title: "Info",
          roles: ['superadmin', 'jobster', 'user']
        },
      ],
      campaignHeaders: [
        { text: "Open position", value: "title" },
        { text: "Company", value: "employer.name" },
        { text: "Area", value: "location.area" },
        { text: "Location", value: "location.city" },
      ],
      campaignFilter: "",
      campaignFilters: [
        { text: "All", value: "" },
        { text: "Published", value: "published" },
        { text: "Draft", value: "draft" },
      ],
      editCampaign: false,
      selectedCampaign: null,
      showCampaignJobs: false,
      userFilter: "",
      userFilters: [
        { text: "All", value: "" },
        { text: "Admin", value: "admin" },
        { text: "Jobster", value: "jobster" },
        { text: "Content producer", value: "content-producer" },
      ],
      editUser: false,
      selectedUser: {},
      currentRoles: [null],

      pageFilter: "",
      pageFilters: [{ text: "All", value: "" }],
      editPage: false,
      selectedPage: {},
      selectedPolicy: {},
    };
  },
  mounted() {
    if (!this.$store.state.JWT) {
      this.showLogin = true;
    }
    // this.loginUser("lauri", "password123");
    this.$store.dispatch("dispatchGetPages");
  },
  watch: {
    $route(to, from) {
      // Refresh job list when navigating to jobs
      if (to.name == "admin" && from.name !== "admin") {
        this.refresh();
      }
    },
  },
  methods: {
    loginUser(username, password) {
      this.showLogin = false;
      this.loading = true;
      if (!this.$store.state.JWT) {
        this.$store
          .dispatch("dispatchLogin", { username, password })
          .catch((error) => {
            if (error.response.status === 401) {
              //alert("Sign-in failed (invalid login credentials)");
              this.loginAlert = "Sign-in failed (invalid login credentials)";
            }
            console.log(error);
            this.errored = true;
            this.showLogin = true;
          })
          .then((auth) => {

            if(this.$route.query.action == 'onboarding'){
              this.$router.push({name: 'users-admin', query: { userId: auth.id }});
            }

            console.log("start dispatchGetJobsAdmin");
            this.$store
              .dispatch("dispatchGetJobsAdmin")
              .then(() => {
                console.log("results from dispatchGetJobsAdmin");
              })
              .finally(() => {
                console.log("finalized dispatchGetJobsAdmin");
                this.errored = false;
                this.loading = false;
              });

            // Get user details
            this.$store
              .dispatch("dispatchGetUserRoles", { userId: auth.id, own: true })
              .then((userRoles) => {
                this.currentRoles = userRoles.inherits;
                this.loggedIn = true;
              }).catch(() => {
                // TODO/FIXME: Other roles should be returned from BE
                this.currentRoles = ["jobster"];
                this.loggedIn = true;
              });

          });

        this.$store.dispatch("dispatchCategories");
        this.$store.dispatch("dispatchTags");
      } else {
        this.loading = false;
      }
    },
    refresh() {
      console.log("refreshing results");
      this.loading = true;
      this.$store.dispatch("dispatchGetJobsAdmin").finally(() => {
        this.errored = false;
        this.loading = false;
      });
    },
    selectCampaign(campaign) {
      console.log(campaign);
      // this.editCampaign = true;
      this.selectedCampaign = campaign;
      if (
        campaign.filters.areas.length > 0 ||
        campaign.filters.categories.length > 0
      ) {
        console.log("Campaign has search terms");

        this.$store.dispatch("dispatchGetJobs").then((jobs) => {
          this.showCampaignJobs = false;

          let terms = {
            area: campaign.filters.areas.join(""),
            keywords: campaign.filters.categories.join(""),
          };

          this.$store.dispatch("commitSearchTerms", terms);
          this.$store.dispatch("commitSearchResults", terms);
        });
      } else {
        console.log("Campaign has selected jobs");

        this.$store
          .dispatch("dispatchGetCampaignJobs", { campaignId: campaign.id })
          .then(() => {
            this.showCampaignJobs = true;

            let terms = {
              area: "",
              keywords: "",
            };

            this.$store.dispatch("commitSearchTerms", terms);
            this.$store.dispatch("commitSearchResults", terms);
          });
      }
    },
    campaignCreated(campaign) {
      this.editCampaign = false;
      this.$store.dispatch("dispatchGetCampaigns").then(() => {
        this.selectCampaign(campaign);
      });
    },
    addUser() {
      this.editUser = true;
      this.selectedUser = {};
    },
    selectUser(user) {
      if (this.selectedUser == user) {
        this.editUser = false;
        this.selectedUser = {};
      } else {
        this.editUser = true;
        this.selectedUser = user;
      }
    },
    userSaved(user) {
      console.log(user);
      this.editUser = false;
      this.selectedUser = {};
      this.$store.dispatch("dispatchGetUsers");
    },
    selectPage(page) {
      if (this.selectePage == page) {
        this.editPage = false;
        this.selectedPage = {};
      } else {
        this.editPage = true;
        this.selectedPage = page;
      }
    },
    pageSaved(page) {
      this.editPage = false;
      this.selectedPage = {};
    },
    checkAccess(roles){
      let hasAccess = false;
      this.currentRoles.forEach((role) => {
        if(roles.includes(role)){
          hasAccess = true;
        }
      });
      return hasAccess;
    }
  },
  computed: {
    // Get data from vuex store
    getSearchResults() {
      console.log("getting search results");
      return this.$store.state.searchResults.filter((el) => el.match);
    },
    getSelectedPosition() {
      return this.$store.state.selectedPosition;
    },
    getSearchTerms() {
      return this.$store.state.searchTerms;
    },
    getCampaignJobs() {
      return this.$store.state.campaignJobs;
    },
    loginAction() {
      return this.$route.name;
    },
    getPage() {
      let page = this.$store.state.pages.find((page) => page.id === "info");

      return page;
    },
  },
};
</script>
<style scoped>
.main-search {
  margin-top: 0.5em;
  margin-bottom: -0.8em;
}
@media screen and (min-width: 992px) {
  .search-row {
    padding: 0em 1.6em;
  }
}
</style>
<style>
.v-data-table tbody tr:hover {
  cursor: pointer;
}
</style>